import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ProductsFamiliesModelService} from '../../../Models/Purchases/Products/products-families-model.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsFamiliesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ProductsFamiliesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las familias de los productos
   *
   */
  public getProductsFamilies(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProductosFamilias', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
